import { ReactComponent as ArrowBoldRight } from './arrow-bold-right.svg';
import { ReactComponent as ArrowRight } from './arrow-right.svg';
import { ReactComponent as ArrowLeft } from './arrow-left.svg';
import { ReactComponent as ErrorLicensePlates } from './error-license-plates.svg';
import { ReactComponent as ErrorLocation } from './error-location.svg';
import { ReactComponent as FileType } from './filetype.svg';
import { ReactComponent as Infotip } from './infotip.svg';
import { ReactComponent as Phone } from './phone.svg';
import { ReactComponent as Search } from './search.svg';
import { ReactComponent as TimeSpeed } from './time-speed.svg';
import { ReactComponent as UploadFile } from './upload-file.svg';
import { ReactComponent as Logo } from './logo.svg';

export const tuwIconsList = {
  Logo,
  ArrowBoldRight,
  ArrowRight,
  ArrowLeft,
  ErrorLicensePlates,
  ErrorLocation,
  FileType,
  Infotip,
  Phone,
  Search,
  TimeSpeed,
  UploadFile,
};
